import React from "react";
import { Form, Button, Spin } from "antd";
import { ReactSVG } from "react-svg";

import "./BulkDelete.scss";

import { useSelector } from "react-redux";
import { getTranslation } from "../../../utils/helper";

const BulkDeleteForm = ({ form, isFetching, items, handleSubmit, handleCancel }) => {
  const user = useSelector(state => state.auth.user);
  const setting = user.company;

  return (
    <Spin spinning={isFetching}>
      <div className="BulkDeleteForm">
        <Form form={form} scrollToFirstError layout="vertical" hideRequiredMark colon={false} onFinish={handleSubmit}>
          <div className="FormHeader">
            <div className="left">{getTranslation(setting, "Orders", "Bulk Delete")}</div>
          </div>
          <div className="FormContent">
            <div className="ContentBulkDelete">
              <div className="Title">
                {getTranslation(setting, "Orders", "Are you sure you want to delete the orders below?")}
              </div>
              <div className="OrderCodeList scrollCustom">
                {items.map((item, index) => (
                  <div className="OrderCode" key={index}>
                    {item.orderCode}
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="FormFooter">
            <div className="Left"></div>
            <div className="Right">
              <Button key="cancel" onClick={handleCancel}>
                {getTranslation(setting, "Common", "Cancel")}
              </Button>
              <Button htmlType="submit" type="primary">
                {getTranslation(setting, "Common", "Confirm")}
                <ReactSVG className="icon" src="/icons/submit.svg" />
              </Button>
            </div>
          </div>
        </Form>
      </div>
    </Spin>
  );
};

export default BulkDeleteForm;
